module.exports = "<app-thick-header></app-thick-header>\n<app-thin-header></app-thin-header>\n"